import { graphql } from "@/gql";

export const DASHBOARD_QUERY = graphql(`
  query DASHBOARD_QUERY($organizationId: String!) {
    organization(id: $organizationId) {
      id
      organizationMetric {
        guardmesActive
        incidentsActive
      }
    }
  }
`);
